export default __webpack_public_path__ + "static/media/noRace.adbb5531.png";